<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <div>
    <f7-list style="margin: 0px 0px 500px 0px;">
      <f7-list-item inline-label ref="price">
        <f7-label>加 / 減價:</f7-label>
        <f7-input type="number" placeholder="ex. 5.5" :value="option.price" @input="updatePrice($event.target.value)" @focus="onFocus('price')" clear-button />
      </f7-list-item>
      <template>
        <f7-list-item title="站點" group-title></f7-list-item>
        <f7-list-item
          checkbox
          v-for="(workStation, key) in workStationList"
          :key="`workStation-${key}`"
          :title="workStation.id"
          :checked="optionKitchenStationId[workStation.id] ? true : false"
          @change="onWorkStationSelectChanged($event.target.checked, workStation.id, option.itemId)">
        </f7-list-item>
      </template>
      <f7-list>
    </f7-list>
      <f7-list-item v-if="elementLevel === 4" title="編輯下層選項" link="#" @click="showQuestions"/>
    </f7-list>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { storeClient } from '@/service/apiClients'

export default {
  dependencies: ['questionType'],
  props: {
    storeId: String,
    menuDraftVariation: String,
    questionId: String
  },
  data () {
    return {
      elementLevel: 0,
      workStationList: [],
      relatedWorkStation: []
    }
  },
  async created () {
    this.elementLevel = this.currentElementPath.length === 6 ? 6 : 4
    const { data: workStationList } = await storeClient.get(`stores/${this.storeId}/kitchenStations`)
    this.workStationList = workStationList
  },
  computed: {
    ...mapState('menuDraftModule', ['currentDraft', 'currentElementPath']),
    question () { return this.currentDraft.questions[this.questionId] },
    optionId () { return this.currentDraft.questions[this.questionId].options[0] },
    option () { return this.currentDraft.options[this.optionId] },
    defaultValue () { return !!this.question.defaultValue },
    optionKitchenStationId () { return this.option.kitchenStationId ? this.option.kitchenStationId : {} }
  },
  methods: {
    ...mapActions('menuDraftModule', ['setCurrentElementPath', 'setQuestionProperties', 'setOptionProperties']),
    showQuestions () {
      if (this.currentElementPath[this.currentElementPath.length - 1] !== this.optionId) {
        this.setCurrentElementPath(this.currentElementPath.concat([{ id: this.optionId, index: 0 }]))
      }
      this.$f7router.navigate(`/stores/${this.storeId}/menu-drafts/${this.menuDraftVariation}/edit-option`)
    },
    updatePrice (v) {
      const properties = { price: parseFloat(v) || 0 }
      this.setOptionProperties({ questionId: this.questionId, optionId: this.optionId, index: 0, elementLevel: this.elementLevel, properties })
    },
    onWorkStationSelectChanged (isChecked, kitchenStationId, itemId) {
      let isItemOption = false
      let relates = Object.assign({}, this.option.kitchenStationId ? this.option.kitchenStationId : {})

      if (isChecked) {
        relates[kitchenStationId] = true
      } else {
        delete relates[kitchenStationId]
      }

      this.workStationList.map(k => {
        if (relates[k.id]) isItemOption = true
      })

      this.setOptionProperties({
        questionId: this.questionId,
        optionId: this.optionId,
        elementLevel: this.elementLevel,
        properties: {
          kitchenStationId: relates,
          isItemOption: isItemOption
        }
      })
    },
    onFocus (field) {
      this.$refs[field].$el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    },
    async updateIsItem (prop, v) { // 更新是否為商品
      if (v) {
        this.setOptionProperties({ questionId: this.questionId, optionId: this.optionId, elementLevel: this.elementLevel, properties: { isItemOption: true } })
      } else {
        this.setOptionProperties({ questionId: this.questionId, optionId: this.optionId, elementLevel: this.elementLevel, properties: { isItemOption: false } })
      }
    }
  }
}
</script>
